import type { PublicStage, PublicTask } from "@/services/public-view.service";
import type { TaskProfile } from "@/services/task.service";

export const FALLBACK_STAGE_COLOR = "#64748b";

// AvatarStack expects TaskProfile; the public payload never carries emails.
export function publicAssignees(task: PublicTask): TaskProfile[] {
	return [task.assigned_to, ...task.additional_assignees]
		.filter((p) => !!p)
		.map((p) => ({ ...p, email: "" }));
}

// Board columns: known stages in order, plus any key only seen on tasks.
// Cancelled is left off, matching the internal board. Empty columns are
// dropped so filtered views stay compact.
export function groupByStage(tasks: PublicTask[], stages: PublicStage[]) {
	const byKey = new Map<string, PublicTask[]>();
	for (const t of tasks) {
		if (t.status === "cancelled") continue;
		byKey.set(t.status, [...(byKey.get(t.status) ?? []), t]);
	}
	const known = new Set(stages.map((s) => s.key));
	const extra = [...byKey.keys()]
		.filter((k) => !known.has(k))
		.map((key) => ({ key, name: key, color: FALLBACK_STAGE_COLOR }));

	return [...stages, ...extra]
		.filter((s) => byKey.has(s.key))
		.map((stage) => ({ stage, tasks: byKey.get(stage.key)! }));
}
